export const formatDuration = (secs) => {
  const parsedSecs = parseInt(secs)

  const minutes = Math.floor(parsedSecs / 60);
  let seconds = parsedSecs - (minutes * 60);
  if (seconds < 10) seconds = `0${seconds}`;
  return `${minutes}:${seconds}`
}